import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HybridAdapterUtility } from '../../Hybrid/hybrid-adapter.utility';
import { AgGridModule } from 'ag-grid-angular';
import { WeissmanSharedModule } from '../../Common/weissman-shared.module';
import { SharedPipesModule } from '../../UI-Lib/Pipes/shared-pipes.module';
import { BusyIndicatorModule } from '../../Busy-Indicator';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { AgGridExtensionsModule } from '../../Compliance/AgGrid/agGridExtensions.module';
import { ImportRecalculationErrorsListComponent } from './Import-Recalculation-Errors-List/importRecalculationErrorsList.component';
import { ImportRecalculationErrorsListGridActionCellRendererComponent } from './Import-Recalculation-Errors-List/agGridActionCellRenderer.component';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        WeissmanSharedModule,
        SharedPipesModule,
        BusyIndicatorModule.forRoot(),
        AgGridExtensionsModule,
        AgGridModule
    ],
    declarations: [
        ImportRecalculationErrorsListComponent,
        ImportRecalculationErrorsListGridActionCellRendererComponent
    ],
    providers: [],
    exports: []
})
export class ImportRecalculationErrorsModule {
    static setupModule(): void {
        const hybridAdapterUtility = new HybridAdapterUtility();
        hybridAdapterUtility.downgradeNg2Component('importRecalculationErrorsList', ImportRecalculationErrorsListComponent);
    }
}
